import { SortDirection } from "../../../../../../api/src/_core/utils/utils.paging";

export class InputUtils {
	public static conditionalSort(items: any | any[], order?: SortDirection, optionValueKey?: string): any | any[] {
		if (order) {
			return items.sort((a, b) => {
				if (optionValueKey) {
					if (order === SortDirection.ASC) {
						return a[optionValueKey].localeCompare(b[optionValueKey]);
					} else {
						return b[optionValueKey].localeCompare(a[optionValueKey]);
					}
				} else {
					if (order === SortDirection.ASC) {
						return a.localeCompare(b);
					} else {
						return b.localeCompare(a);
					}
				}
			});
		} else return items;
	}
}
